import { getFontSize } from '../../constants/fontSizes';

export const navigateButtonStyles = (isSecondary = false) => {
  const bookStayBgColor = isSecondary ? 'secondary' : 'primary';
  const bookStayTextColor = isSecondary ? 'primary' : 'secondary';
  const iconColor = isSecondary ? 'primary' : 'secondary';

  return {
    button: {
      backgroundColor: bookStayBgColor === 'secondary' ? 'secondary.main' : 'primary.main',
      textTransform: 'none',
      '&:hover': {
        backgroundColor: bookStayBgColor === 'secondary' ? 'secondary.dark' : 'primary.dark',
      },
      borderRadius: '52px',
      padding: {xs: '5px 15px', lg: '10px 20px'},
    },
    textStyle: {
      fontWeight: 600,
      fontSize: getFontSize(18),
      color: bookStayTextColor === 'primary' ? 'primary.main' : 'secondary.main',
    },
    iconBox: {
      width: 42,
      height: 42,
      borderRadius: '50%',
      backgroundColor: iconColor === 'primary' ? 'primary.main' : '#FFFFFF1C',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      ml: 0.5,
    },
    icon: {
      fontSize: 20,
      color: 'secondary.main'
    },
  };
};
